<div class="wrapper" id="top">
    <app-header *ngIf="visibility"></app-header>
    <router-outlet></router-outlet>
    <app-footer *ngIf="visibility"></app-footer>
</div>

<app-loader></app-loader>